<script lang="ts" setup>
interface Props {
  selected?: boolean;
  disabled?: boolean;
}

withDefaults(defineProps<Props>(), {
  selected: false,
  disabled: false,
});
</script>

<template>
  <div class="f-button" :class="{ selected, disabled }">
    <slot />
  </div>
</template>

<style scoped>
.f-button {
  --f-button-color: var(--ion-color-primary-shade);
  --f-button-bg-color: transparent;

  border-radius: 5px;
  color: var(--f-button-color);
  background-color: var(--f-button-bg-color);
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px;
  line-height: 16px;
  font-size: var(--font-size-m);
  font-weight: 500;
}

.f-button.selected {
  --f-button-color: var(--ion-color-secondary);
  --f-button-bg-color: var(--ion-color-secondary-shade);
}

.f-button.disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
